<script>
import Mixin from "../../utilities/mixin";

export default {
  name: "Settings",
  mixins: [Mixin],
  data() {
    return {
      selectedForm: null,
      customerDataFields: {
        full_name: null,
        drivers_license: null,
        email: null,
        phone: null,
        vehicle_make: null,
        vehicle_model: null,
        vehicle_year: null,
        address: null,
        city: null,
        state: null,
        zip: null,
        service_type: null,
        service_charge: null,
        dmv_estimate: null,
        total: null,
        fee: null,
        contact_status: null,
        owes: null,
        cash_or_credit: null,
        due_date: null,
        vin_number: null,
      }
    }
  },
  computed: {
    forms() {
      return this.$store.state.forms;
    },
    formOptions() {
      return this.forms.map(form => {
        form.id = form.ID;
        form.name = form.post_title;
        return form;
      });
    },
    formQNums() {
      return this.$store.state.formQNums;
    }
  },
  methods: {
    makeIdName({id, name}) {
      return `${id}: ${name}`;
    },
    submitUpdates() {
      this.postFormData(this.selectedForm, this.customerDataFields);
    },
  },
  created() {
    this.getForms();
  },
  watch: {
    formQNums() {
      if (this.formQNums) {
        for (let key of Object.keys(this.customerDataFields)) {
          this.customerDataFields[key] = this.formQNums[key] ?? null;
        }
      }
    },
    selectedForm() {
      this.getFormData(this.selectedForm.id);
    },
    customerDataFields() {
      console.log(this.customerDataFields);
    }
  }
}
</script>

<template>
  <div class="p-4">
    <Panel header="Smog Buddy Settings" class="mb-6">
      <div class="flex flex-col gap-6">
        <div class="flex flex-col md:flex-row gap-6">
          <div class="flex-1">
            <label for="formSelect" class="block mb-2">Select Form</label>
            <Select
                v-model="selectedForm"
                :options="formOptions"
                option-label="name"
                option-value="id"
                :placeholder="'Choose Form'"
                :clearable="true"
                class="w-full"
                :filter="true"
                :label="makeIdName"
                input-id="formSelect"
            />
          </div>
          <div class="flex-1">
            <label for="save-button" class="block mb-2">
              Saves question numbers and form id for document generation.
            </label>
            <Button
                id="save-button"
                label="Save"
                class="p-button-primary w-full md:w-auto"
                @click="submitUpdates"
            />
          </div>
        </div>
        <div class="flex flex-col">
          <div class="flex flex-wrap gap-4">
            <div
                v-for="key of Object.keys(customerDataFields)"
                :key="key"
                class="flex flex-col w-full sm:w-64"
            >
              <label :for="key" class="mb-2">{{ key }}</label>
              <InputNumber
                  :id="key"
                  v-model="customerDataFields[key]"
                  class="w-full"
                  :useGrouping="false"
              />
            </div>
          </div>
        </div>
      </div>
    </Panel>
  </div>
</template>